import { InfoSlide } from '@/mocks/sliderHome';
import Image from 'next/image';
import React from 'react';
import { Pagination, Autoplay, Thumbs, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const Slider = () => {
  return (
    <>
      <Swiper
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        }}
        spaceBetween={10}
        speed={1000}
        loop={true}
        pagination={{
          dynamicBullets: true,
        }}
        navigation={true}
        modules={[Pagination, Autoplay, Navigation, Thumbs]}
        className="relative w-full h-[40vh] md:h-[50vh] min-h-[220px] max-h-[600px] z-10"
      >
        {InfoSlide.map((item, index) => (
          <SwiperSlide key={index} className="relative w-full h-full">
            <Image
              src={item.image}
              alt={item.name ? `Slider ${item.name} - Trường Thọ Food` : 'Slider trang chủ - Trường Thọ Food'}
              fill
              className="object-cover"
            />
            {/* <div className="absolute md:inset-0 bottom-3 md:h-full flex items-center container">
              <div className="flex bg-black/40 p-4 md:p-8 rounded-lg backdrop-blur-sm gap-2 flex-col md:w-1/2">
                <p className="text-[20px] md:text-[32px] font-semibold uppercase text-white">
                  {item.name}
                </p>
                <p className="text-[16px] md:text-[18px] font-normal  text-white">
                  {item.desc}
                </p>
                <p className="text-[16px] md:text-[18px] font-semibold text-white flex gap-2">
                  Ngày hoàn thành: <p className="font-normal">{item.date}</p>
                </p>
                <button className="bg-primary h-fit whitespace-nowrap text-white duration-300 w-fit text-[14px] md:text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-white hover:bg-transparent relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-white">
                  Xem thêm
                </button>
              </div>
            </div> */}
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Slider;
